import {
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Modal,
  Table,
} from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../../../../../components/common/Input";
import CountryDropdown from "../../../../../components/common/CountryDropdown";
import BankAccountType from "../../../../../components/common/dropdowns/BankAccountType";
import { BankDetailsType } from "./types/BankDetailsType";
import LocalBankCurrencies from "../../../../../components/common/dropdowns/LocalBankCurrencies";
import Button from "../../../../../components/common/Button";
import CorrBankAccountDetails from "../../../../guestUser/common/components/BankDetails/CorrBankAccountDetails";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/store";
import { createLocalBankAction } from "../redux/action/createLocalBankAction";
import { useState, useEffect } from "react";
import { getLocalBankAction } from "../redux/action/getLocalBankAction";
import { getAllCorrBankAction } from "../redux/action/getAllCorrBankAction";
import EditCorrBankAccountDetails from "../../../../guestUser/common/components/BankDetails/EditCorrBankAccountDetails";
import { updateLocalBank } from "../apis/updateLocalBank";
import { updateLocalBankAction } from "../redux/action/updateLocalBankAction";
import SectionHeading from "../../../../../components/common/SectionHeading";
import NavbarVTX from "../../../../../components/common/Navbar";
import Header from "../../../../../components/common/Header";
import {
  ADDRESS_REGEX,
  ALPHABETS_REGEX,
  ALPHANUMERIC_REGEX,
  EMAIL_REGEX,
  NON_INDIAN_REGEX,
  PHONE_REGEX,
  PINCODE_REGEX,
  SWIFTCODE_REGEX,
} from "../../../../constants/regexPatterns";
import IsdCode from "../../../../../components/common/dropdowns/IsdCode";
import { DisplayBox } from "../../../../../components/containers/DisplayBox";
import AlertPopup from "../../../../../components/common/Alert/AlertPopup";
import PhoneInputWithDropdown from "../../../../../components/common/PhoneInput";
import BankAccountTypeWOEEFC from "../../../../../components/common/dropdowns/BankAccountTypeWOEEFC";
import RadioButton from "../../../../../components/common/RadioButton";
import BankRadioButton from "../../../../../components/common/BankDeclaration";
import BankAccountTypeWOthers from "../../../../../components/common/dropdowns/BankAccountTypeWOthers";
import { searchAddressByPincodeAction } from "../redux/action/searchAddressByPincodeAction";
import { searchIFSCAction } from "../redux/action/searchIFSCAction";
import { searchBankAction } from "../redux/action/searchBankAction";
import { parseAddress } from "../../../../../utils/functions/parseAddress";
import { parseBankAddress } from "../../../../../utils/functions/parseBankAddress";

const OpsEditLocalBankPage: React.FC = () => {
  let { appId, bankId } = useParams();
  let localBankId = Number(bankId);
  let customerId = Number(appId);

  const dispatch = useDispatch<AppDispatch>();

  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );
  let role = getAppSelector.data.business_participant_type;
  const isIndia =
    getAppSelector.data.business_registration_country_id ===
    Number(process.env.REACT_APP_COUNTRY_ID);

  const localBankDetails = useSelector(
    (state: RootState) => state.opsPpIndApp.getLocalBank.data
  );
  const allLocalBank = useSelector(
    (state: RootState) => state.opsPpIndApp.getAllLocalBank.data
  );

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    setValue,
    formState: { errors },
  } = useForm<BankDetailsType>({ shouldUnregister: true });
  type PostOffice = {
    Name: string;
    BranchType: string;
    District: string;
    State: string;
    Pincode: string;
    Block: string;
    Country: string;
  };
  // const [corrBanks, setCorrBanks] = useState([]);
  const [showLocalBankSuccess, setShowLocalBankSuccess] = useState(false);
  const accountNumber = watch("bank_account_number");
  const confirmAccountNumber = watch("re_enter_bank_account_number");
  const [showSpinner, setShowSpinner] = useState(false);
  const localCurrency = watch("currency_id");
  const [hideEEFC, setHideEEFC] = useState(false);
  const [bankAccNo, setBankAccNo] = useState("");
  const [reBankAccNo, setReBankAccNo] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const bankAccountType = watch("account_type");
  const isCountryIndia =
    Number(watch("bank_address_country_id")) ===
    Number(process.env.REACT_APP_COUNTRY_ID);

  //colored fields
  const [bankNameFetched, setBankNameFetched] = useState(false);
  const [branchNameFetched, setBranchNameFetched] = useState(false);
  const [addLine1Fetched, setAddLine1Fetched] = useState(false);
  const [addLine2Fetched, setAddLine2Fetched] = useState(false);
  const [pincodeFetched, setPincodeFetched] = useState(false);
  const [cityFetched, setCityFetched] = useState(false);
  const [districtFetched, setDistrictFetched] = useState(false);
  const [stateFetched, setStateFetched] = useState(false);
  const [countryFetched, setCountryFetched] = useState(false);
  const [nameBankAccFetched, setNameBankAccFetched] = useState(false);

  useEffect(() => {
    reset({
      bank_name: localBankDetails.bank_name,
      bank_account_name: localBankDetails.bank_account_name,
      branch_name: localBankDetails.branch_name,
      bank_account_number: localBankDetails.bank_account_number,
      re_enter_bank_account_number:
        localBankDetails.re_enter_bank_account_number,
      swift_code: localBankDetails.swift_code,
      ifsc_code: localBankDetails.ifsc_code,
      // account_type: localBankDetails.account_type,
      bank_address_line_1: localBankDetails.bank_address_line_1,
      bank_address_line_2: localBankDetails.bank_address_line_2,
      bank_address_pincode:
        localBankDetails.bank_address_pincode === "0"
          ? ""
          : localBankDetails.bank_address_pincode,
      bank_address_state: localBankDetails.bank_address_state,
      bank_address_city: localBankDetails.bank_address_city,
      bank_address_country_id: localBankDetails.bank_address_country_id,
      bank_address_district: localBankDetails.bank_address_district,
      bank_official_email: localBankDetails.bank_official_email,
      bank_official_mobile: localBankDetails.bank_official_mobile,
      bank_official_name: localBankDetails.bank_official_name,
      bank_official_phone: localBankDetails.bank_official_phone,
      phone_country_code: localBankDetails.phone_country_code,
      mobile_country_code: localBankDetails.mobile_country_code,
      currency_id: localBankDetails.currency_id,
      // account_type: localBankDetails.account_type,
      // other_account_type: localBankDetails.other_account_type,
      is_default_bank: localBankDetails.is_default_bank,
      undertaking_confirm: localBankDetails.undertaking_confirm,
    });
    setPincodeValue(
      localBankDetails.bank_address_pincode === "0"
        ? ""
        : localBankDetails.bank_address_pincode
    );
    setIfscCode(localBankDetails.ifsc_code);
    setBankAccNo(localBankDetails.bank_account_number);
    setReBankAccNo(localBankDetails.re_enter_bank_account_number);

    setTimeout(() => {
      reset({
        bank_address_country_id: localBankDetails.bank_address_country_id,
        // account_type: localBankDetails.account_type,
        undertaking_confirm: localBankDetails.undertaking_confirm,
      });
    }, 500);

    localBankDetails.api_line_1_flag == true
      ? setAddLine1Fetched(true)
      : setAddLine1Fetched(false);
    localBankDetails.api_line_2_flag == true
      ? setAddLine2Fetched(true)
      : setAddLine2Fetched(false);
    localBankDetails.api_bank_name_flag == true
      ? setBankNameFetched(true)
      : setBankNameFetched(false);
    localBankDetails.api_branch_name_flag == true
      ? setBranchNameFetched(true)
      : setBranchNameFetched(false);
    localBankDetails.api_account_name_flag == true
      ? setNameBankAccFetched(true)
      : setNameBankAccFetched(false);
    localBankDetails.api_city_flag == true
      ? setCityFetched(true)
      : setCityFetched(false);
    localBankDetails.api_district_flag == true
      ? setDistrictFetched(true)
      : setDistrictFetched(false);
    localBankDetails.api_state_flag == true
      ? setStateFetched(true)
      : setStateFetched(false);
    localBankDetails.postal_pincode_api_success == true
      ? setPincodeFetched(true)
      : setPincodeFetched(false);
    localBankDetails.api_country_flag == true
      ? setCountryFetched(true)
      : setCountryFetched(false);
  }, [localBankDetails]);

  // useEffect(() => {
  //   if (localBankDetails.currency_id && localCurrency) {
  //     setTimeout(() => {
  //       reset({
  //         // bank_address_country_id: localBankDetails.bank_address_country_id,
  //         account_type: localBankDetails.account_type,
  //         // undertaking_confirm: localBankDetails.undertaking_confirm,
  //       });
  //       // console.warn(localBankDetails.account_type);
  //       const accountType = localBankDetails.account_type;
  //       setValue("account_type", accountType);
  //     }, 1000);
  //   }
  // }, []);

  useEffect(() => {
    dispatch(getLocalBankAction(localBankId));
  }, []);

  const countryId = watch("bank_address_country_id");

  useEffect(() => {
    // if (localCurrency == 12) {
    //   // console.log("true");
    //   setHideEEFC(true);
    // } else {
    //   // console.log("false");
    //   setHideEEFC(false);
    // }
    setTimeout(() => {
      setValue("account_type", localBankDetails.account_type);
      setValue("other_account_type", localBankDetails.other_account_type);
    }, 1000);
  }, [localBankDetails.account_type, localCurrency, reset, setValue]);

  const handleIFSCSearch = () => {
    dispatch(searchIFSCAction(ifscCode)).then((resp) => {
      if (resp.payload?.result?.result) {
        const ifscDetails = resp.payload.result.result;
        const address = parseBankAddress(ifscDetails.address);

        // Set common values
        setValue("bank_name", ifscDetails.bank);
        setValue("branch_name", ifscDetails.branch);
        setValue("bank_address_line_1", address.line_1);
        setValue("bank_address_line_2", address.line_2);
        setValue(
          "bank_address_country_id",
          Number(process.env.REACT_APP_COUNTRY_ID)
        );

        if (address.pincode) {
          const cleanPincode = address.pincode.replace(/\.$/, "");
          setValue("bank_address_pincode", Number(cleanPincode));
          setPincodeValue(cleanPincode);
        }

        // Prioritize IFSC values; fallback to address-parsed values
        const district = ifscDetails.district || address.district;
        const city = ifscDetails.city || address.city;
        const state = ifscDetails.state || address.state;

        if (district) setValue("bank_address_district", district);
        if (city) setValue("bank_address_city", city);
        if (state) setValue("bank_address_state", state);

        // Flags - use boolean checks for whether they were populated
        const flagSetters = [
          { setter: setBankNameFetched, value: ifscDetails.bank },
          { setter: setBranchNameFetched, value: ifscDetails.branch },
          { setter: setAddLine1Fetched, value: address.line_1 },
          { setter: setAddLine2Fetched, value: address.line_2 },
          { setter: setPincodeFetched, value: address.pincode },
          { setter: setCityFetched, value: city },
          { setter: setDistrictFetched, value: district },
          { setter: setStateFetched, value: state },
          { setter: setCountryFetched, value: true }, // always true if static
        ];

        flagSetters.forEach(({ setter, value }) => {
          if (value) setter(true);
        });
      } else {
        alert("Could not find the IFSC details");
      }
    });
  };

  const handleIfscCodeChange = (e: any) => {
    const value = e.target.value.toUpperCase();
    setIfscCode(value);
    setValue("ifsc_code", value);
  };

  const handleSwiftCodeChange = (e: any) => {
    const value = e.target.value.toUpperCase();
    setValue("swift_code", value);
  };

  const [showPincodeSearchModal, setPincodeSearchShowModal] = useState(false);
  const handlePincodeSearchModalOpen = () => setPincodeSearchShowModal(true);
  const handlePincodeSearchModalClose = () => setPincodeSearchShowModal(false);

  const [showPincodeSearch, setShowPincodeSearch] = useState(false);
  const [pincodeValue, setPincodeValue] = useState("");
  const [addressByPincode, setAddressByPincode] = useState<PostOffice[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<PostOffice | null>(
    null
  );
  const [searchAddrSpinner, setSearchAddrSpinner] = useState(false);
  // const pincode = watch("pincode");
  const handleSearchPincode = async () => {
    setSearchAddrSpinner(true);
    dispatch(searchAddressByPincodeAction(pincodeValue)).then((resp) => {
      const postOffices: PostOffice[] =
        resp.payload?.result?.[0]?.PostOffice || [];
      if (resp.payload?.result?.[0]?.Status === "Success") {
        setAddressByPincode(postOffices);
        handlePincodeSearchModalOpen();
        setSearchAddrSpinner(false);
      } else {
        alert("Could not fetch the address");
        setSearchAddrSpinner(false);
      }
    });
  };

  const handleClosePincodeSearchModal = () => {
    handlePincodeSearchModalClose(); // Close the modal
    setSearchAddrSpinner(false); // Stop the spinner
  };

  const handleSearchBank = () => {
    // console.log(accountNumber);
    if (bankAccNo !== reBankAccNo) {
      alert("Bank Account Number does not match");
      return;
    }
    if (ifscCode && bankAccNo) {
      dispatch(searchBankAction({ ifscCode, bankAccNo })).then((resp) => {
        if (resp.payload?.result?.result) {
          // console.log(resp.payload);
          const data = resp.payload?.result?.result?.data?.source[0]?.data;
          setValue("bank_account_name", data?.accountName);
          if (data.accountName) {
            setNameBankAccFetched(true);
          }
        } else {
          alert("Could not get Bank Details");
        }
      });
      // }
      // else {
      //   alert("Bank account number does not match");
      // }
    } else {
      alert("Please enter IFSC and Bank Account Number");
    }
  };

  const handleBankDetailsSubmit: SubmitHandler<BankDetailsType> = (data) => {
    if (accountNumber !== confirmAccountNumber) {
      setError("re_enter_bank_account_number", {
        type: "manual",
        message: "Account Number do not match",
      });
      return;
    }

    if (
      data.phone_country_code == "+91" &&
      data.bank_official_phone?.length !== 10
    ) {
      alert("Please enter 10 digit Official Phone");
      return;
    }

    setShowSpinner(true);

    const bankDetails = {
      ...data,
      // bank_address_pincode: Number(data.bank_address_pincode),
      // undertaking_confirm: declarationValue,
      // bank_address_country_id: data.bank_address_country_id === 0 ? "false" : Number(data.bank_address_country_id),
      currency_id: Number(data.currency_id),

      api_line_1_flag: addLine1Fetched ? true : false,
      api_line_2_flag: addLine2Fetched ? true : false,
      api_bank_name_flag: bankNameFetched ? true : false,
      api_branch_name_flag: branchNameFetched ? true : false,
      api_account_name_flag: nameBankAccFetched ? true : false,
      api_city_flag: cityFetched ? true : false,
      api_district_flag: districtFetched ? true : false,
      api_state_flag: stateFetched ? true : false,
      api_country_flag: countryFetched ? true : false,
      postal_pincode_api_success: pincodeFetched ? true : false,
    };
    // console.log(data.bank_address_country_id);
    const country = data.bank_address_country_id;
    // console.warn(countryId);
    if (!data.bank_address_country_id) {
      bankDetails.bank_address_country_id = false;
    } else {
      bankDetails.bank_address_country_id = Number(
        data.bank_address_country_id
      );
    }

    // console.log("bank--", bankDetails);
    dispatch(
      updateLocalBankAction({ localBankId, updateLocalBankData: bankDetails })
    ).then((response) => {
      if (response.payload.result.error) {
        alert(response.payload.result.error.data.message);
        setShowSpinner(false);
      } else {
        // alert("Bank Updated!");
        setShowLocalBankSuccess(true);
        setTimeout(() => {
          setShowLocalBankSuccess(false);
        }, 2000);
        setShowSpinner(false);
      }
    });
  };

  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  type Bank = {
    currency_id?: {
      currency_code: string;
    };
    // Add other fields as needed
  };

  const handleCurrencyChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedText = event.target.options[event.target.selectedIndex].text;
    setSelectedCurrency(selectedText); // save for modal display

    const matchFound = allLocalBank.some(
      (bank: Bank) => bank.currency_id?.currency_code === selectedText
    );

    if (matchFound) {
      setShowCurrencyModal(true);
      // console.log("yes");
      return;
    }

    // Continue with your logic
    if (selectedText === "INR") {
      setHideEEFC(true);
    } else {
      setHideEEFC(false);
    }
  };

  return (
    <>
      <Container>
        <NavbarVTX />
        <Header />
        <Row>
          <Row>
            <Row>
              <Col md={20} className="mt-4" style={{ color: "#214382" }}>
                <SectionHeading text="EDIT LOCAL BANK ACCOUNT" />
              </Col>
            </Row>

            <DisplayBox display={showLocalBankSuccess}>
              <AlertPopup
                variant="success"
                message="Bank Updated Successfully!"
              />
            </DisplayBox>
          </Row>
          <Row>
            <Row>
              <Col md={20} className="bank-account-col">
                <SectionHeading text="LOCAL BANK DETAILS" />
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  color: "red",
                }}
                className="text-center"
              >
                {role !== "Financier" &&
                  `(Enter the working capital bank account details (CC/OD/EEFC). In
                absence of working capital facilities, enter current account
                details)`}
              </p>
            </Row>

            <Form
              style={{ width: "119%" }}
              onSubmit={handleSubmit(handleBankDetailsSubmit)}
            >
              <Row style={{ marginTop: "30px" }}>
                <Col sm={6} className="d-flex align-items-center">
                  <LocalBankCurrencies
                    label="Local Bank Currency"
                    name="currency_id"
                    register={register}
                    required
                    requiredMessage="Currency is required"
                    error={errors.currency_id?.message}
                    onChange={handleCurrencyChange}
                  />
                </Col>
              </Row>
              {/* <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Bank name"
                    name="bank_name"
                    register={register}
                    placeholder="Enter bank name"
                    required
                    regexPattern={ALPHABETS_REGEX}
                    requiredMessage="Bank Name is required"
                    error={errors.bank_name?.message}
                  />
                </Col>
                <Col sm={6}>
                  {getAppSelector.data.is_counterparty === true && (
                    <p style={{ fontSize: "smaller", color: "red" }}>
                      Following fields are not applicable for Counter Party
                      Applications
                    </p>
                  )}
                  <Input
                    label="Address line 1"
                    name="bank_address_line_1"
                    register={register}
                    placeholder="Enter address line 1"
                    regexPattern={ADDRESS_REGEX}
                    required
                    requiredMessage="Address line 1 is required"
                    error={errors.bank_address_line_1?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "1px" }}>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Branch name"
                    name="branch_name"
                    register={register}
                    regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter branch name"
                    required
                    requiredMessage="Address is required"
                    error={errors.branch_name?.message}
                  />
                </Col>
                <Col sm={6}>
                  <Input
                    label="Address line 2"
                    name="bank_address_line_2"
                    register={register}
                    // regexPattern={ALPHANUMERIC_REGEX}
                    placeholder="Enter address line 2"
                    // required
                    // requiredMessage="Email is required"
                    error={errors.bank_address_line_2?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Bank account no"
                    type="password"
                    name="bank_account_number"
                    register={register}
                    placeholder="Enter bank account no"
                    required
                    requiredMessage="Address is required"
                    error={errors.bank_account_number?.message}
                  />
                </Col>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="District/City Area"
                    name="bank_address_district"
                    register={register}
                    regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter district"
                    // required
                    // requiredMessage="city is required"
                    error={errors.bank_address_district?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Re-enter Bank account no"
                    // type="password"
                    name="re_enter_bank_account_number"
                    register={register}
                    placeholder="Enter re-enter bank account no"
                    required
                    requiredMessage="Bank account number is required"
                    error={errors.re_enter_bank_account_number?.message}
                  />
                </Col>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="State/County"
                    name="bank_address_state"
                    register={register}
                    placeholder="Enter state"
                    regexPattern={ALPHABETS_REGEX}
                    // required
                    // requiredMessage="state is required"
                    error={errors.bank_address_state?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Name as per bank account"
                    name="bank_account_name"
                    register={register}
                    placeholder="Enter name as per bank account"
                    // required
                    // requiredMessage="Bank account name is required"
                    error={errors.bank_account_name?.message}
                  />
                </Col>
                <Col sm={6} className="d-flex align-items-center">
                  <CountryDropdown
                    label="Country"
                    name="bank_address_country_id"
                    register={register}
                    // required
                    // requiredMessage="pincode is required"
                    error={errors.bank_address_country_id?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="IFSC/Sort Code/ABA"
                    name="ifsc_code"
                    register={register}
                    // regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter IFSC/Sort code/ABA"
                    required
                    requiredMessage="IFSC/Sort code/ABA is required"
                    error={errors.ifsc_code?.message}
                    onChange={handleIfscCodeChange}
                  />
                </Col>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="City/Town/Locality"
                    name="bank_address_city"
                    register={register}
                    regexPattern={ALPHABETS_REGEX}
                    // required
                    // requiredMessage="city is required"
                    error={errors.city?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Swift code / BIC"
                    name="swift_code"
                    register={register}
                    // regexPattern={SWIFTCODE_REGEX}
                    placeholder="Enter swift code"
                    required
                    requiredMessage="country is required"
                    error={errors.swift_code?.message}
                    onChange={handleSwiftCodeChange}
                  />
                </Col>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Pin Code/ Postal Code/ Zip"
                    name="bank_address_pincode"
                    register={register}
                    regexPattern={
                      isCountryIndia ? PINCODE_REGEX : NON_INDIAN_REGEX
                    }
                    placeholder="Enter pincode/zipcode"
                    // required
                    // requiredMessage="email is required"
                    error={errors.bank_address_pincode?.message}
                    disabled={
                      getAppSelector.data.is_counterparty === true
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  {role === "Financier" ? (
                    <BankAccountTypeWOthers
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  ) : hideEEFC ? (
                    <BankAccountTypeWOEEFC
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  ) : (
                    <BankAccountType
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  )}
                </Col>
                {bankAccountType === "Others" && (
                  <Input
                    label={"If Others,"}
                    name={"other_account_type"}
                    register={register}
                    placeholder="Please Specify Account Type"
                    required
                    error={errors.other_account_type?.message}
                  />
                )}
              </Row> */}
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="IFSC/Sort Code/ABA"
                    name="ifsc_code"
                    register={register}
                    // regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter IFSC Code of the working capital Bank branch"
                    required
                    requiredMessage="IFSC/Sort/ABA is required"
                    error={errors.ifsc_code?.message}
                    onChange={handleIfscCodeChange}
                    link={
                      isIndia
                        ? {
                            text: "Fetch details from IFSC",
                            onClick: () => handleIFSCSearch(),
                            // className: "text-end",
                          }
                        : undefined
                    }
                  />
                  {/* <p></p> */}
                </Col>

                <Col sm={6}>
                  {getAppSelector.data.is_counterparty === true && (
                    <p style={{ fontSize: "smaller", color: "red" }}>
                      Following fields are not applicable for Counter Party
                      Applications
                    </p>
                  )}
                  <Input
                    label="Address line 1"
                    name="bank_address_line_1"
                    register={register}
                    regexPattern={ADDRESS_REGEX}
                    placeholder="Enter address line 1"
                    required={!getAppSelector.data.is_counterparty}
                    requiredMessage="Address line 1 is required"
                    error={errors.bank_address_line_1?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={addLine1Fetched}
                    onChange={() => {
                      setAddLine1Fetched(false);
                    }}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "1px" }}>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Bank name"
                    name="bank_name"
                    register={register}
                    placeholder="Enter bank name"
                    required
                    regexPattern={ALPHABETS_REGEX}
                    requiredMessage="Bank Name is required"
                    error={errors.bank_name?.message}
                    colored={bankNameFetched}
                    onChange={() => {
                      setBankNameFetched(false);
                    }}
                  />
                </Col>

                <Col sm={6}>
                  <Input
                    label="Address line 2"
                    name="bank_address_line_2"
                    register={register}
                    // regexPattern={ADDRESS_REGEX}
                    placeholder="Enter address line 2"
                    // required
                    // requiredMessage="Email is required"
                    error={errors.bank_address_line_2?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={addLine2Fetched}
                    onChange={() => {
                      setAddLine2Fetched(false);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Branch name"
                    name="branch_name"
                    regexPattern={
                      branchNameFetched ? undefined : ALPHABETS_REGEX
                    }
                    register={register}
                    placeholder="Enter branch name"
                    required
                    requiredMessage="Branch name is required"
                    error={errors.branch_name?.message}
                    colored={branchNameFetched}
                    onChange={() => {
                      setBranchNameFetched(false);
                    }}
                  />
                </Col>

                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Pin Code/ Postal Code/ Zip"
                    name="bank_address_pincode"
                    register={register}
                    placeholder="Enter pincode/zipcode"
                    regexPattern={
                      isCountryIndia ? PINCODE_REGEX : NON_INDIAN_REGEX
                    }
                    // required
                    // requiredMessage="email is required"
                    error={errors.bank_address_pincode?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    onChange={(e) => {
                      setPincodeValue(e.target.value);
                      setPincodeFetched(false);
                    }}
                    link={
                      !getAppSelector.data?.is_counterparty && isIndia
                        ? {
                            text: "Fetch Address from Pin Code",
                            onClick: () => handleSearchPincode(),
                          }
                        : undefined
                    }
                    colored={pincodeFetched}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Bank account no"
                    type="password"
                    name="bank_account_number"
                    register={register}
                    placeholder="Enter bank account no"
                    required
                    requiredMessage="Account No/ IBAN is required"
                    error={errors.bank_account_number?.message}
                    onChange={(e) => {
                      setBankAccNo(e.target.value);
                      setNameBankAccFetched(false);
                    }}
                  />
                </Col>

                {/* <Col sm={6} className="text-end">
                  <>
                    {searchAddrSpinner ? (
                      <Spinner animation="border" variant="primary"></Spinner>
                    ) : (
                      <Button
                        label={"Fetch Address from Pin Code"}
                        variant="outline-primary"
                        onClick={() => {
                          // openPincodeSearchModal()
                          handleSearchPincode();
                        }}
                      ></Button>
                    )}
                  </>
                </Col> */}
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Re-enter Bank account no"
                    name="re_enter_bank_account_number"
                    // type="password"
                    register={register}
                    placeholder="Enter re-enter bank account no"
                    required
                    requiredMessage="Bank account number/IBAN is required"
                    error={errors.re_enter_bank_account_number?.message}
                    link={
                      isIndia
                        ? {
                            text: "Fetch Name from Account number",
                            onClick: () => handleSearchBank(),
                            // className: "text-end",
                          }
                        : undefined
                    }
                    onChange={(e) => {
                      setReBankAccNo(e.target.value);
                      setNameBankAccFetched(false);
                    }}
                  />
                </Col>

                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="City/Town/Locality"
                    name="bank_address_city"
                    register={register}
                    regexPattern={cityFetched ? undefined : ALPHABETS_REGEX}
                    // required
                    placeholder="Enter City"
                    // requiredMessage="city is required"
                    error={errors.city?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={cityFetched}
                    onChange={() => {
                      setCityFetched(false);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="Name as per bank account"
                    name="bank_account_name"
                    register={register}
                    regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter name as per bank account"
                    // required
                    // requiredMessage="Bank account name is required"
                    // error={errors.bank_account_name?.message}
                    colored={nameBankAccFetched}
                    onChange={() => {
                      setNameBankAccFetched(false);
                    }}
                  />
                </Col>

                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="District/City Area"
                    name="bank_address_district"
                    register={register}
                    regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter district"
                    // required
                    // requiredMessage="city is required"
                    error={errors.bank_address_district?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={districtFetched}
                    onChange={() => {
                      setDistrictFetched(false);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  {/* <Input
                    label="IFSC/Sort Code/ABA"
                    name="ifsc_code"
                    register={register}
                    // regexPattern={ALPHABETS_REGEX}
                    placeholder="Enter IFSC/Sort code/ABA"
                    required
                    requiredMessage="IFSC/Sort/ABA is required"
                    error={errors.ifsc_code?.message}
                    
                    onChange={handleIfscCodeChange}
                  /> */}
                  <Input
                    label="Swift code /BIC"
                    name="swift_code"
                    register={register}
                    placeholder="Enter swift code"
                    required
                    // regexPattern={SWIFTCODE_REGEX}
                    requiredMessage="Swift Code is required"
                    error={errors.swift_code?.message}
                    onChange={handleSwiftCodeChange}
                  />
                </Col>

                <Col sm={6} className="d-flex align-items-center">
                  <Input
                    label="State/County"
                    name="bank_address_state"
                    register={register}
                    placeholder="Enter state"
                    regexPattern={ALPHABETS_REGEX}
                    // required
                    // requiredMessage="state is required"
                    error={errors.bank_address_state?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={stateFetched}
                    onChange={() => {
                      setStateFetched(false);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="d-flex align-items-center">
                  {role === "Financier" ? (
                    <BankAccountTypeWOthers
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  ) : hideEEFC ? (
                    <BankAccountTypeWOEEFC
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  ) : (
                    <BankAccountType
                      label="Account Type"
                      name="account_type"
                      register={register}
                      required
                      requiredMessage="Account type is required"
                      error={errors.account_type?.message}
                    />
                  )}
                </Col>
                {bankAccountType === "Others" && (
                  <Input
                    label={"If Others,"}
                    name={"other_account_type"}
                    register={register}
                    placeholder="Please Specify Account Type"
                    required
                    error={errors.other_account_type?.message}
                  />
                )}
                <Col>
                  <CountryDropdown
                    label="Country"
                    name="bank_address_country_id"
                    register={register}
                    // required
                    // requiredMessage="pincode is required"
                    error={errors.bank_address_country_id?.message}
                    disabled={getAppSelector.data.is_counterparty === true}
                    colored={countryFetched}
                    handleChange={() => {
                      setCountryFetched(false);
                    }}
                  />
                </Col>
              </Row>
              {/*
{!getAppSelector.data.is_counterparty && (
  <div>
    <Row>
      <Col md={20} className="bank-account-col">
        <SectionHeading text="BANK OFFICIALS DETAILS" />
      </Col>
    </Row>
    <Row style={{ marginTop: "30px" }}>
      {getAppSelector.data.is_counterparty === true && (
        <p style={{ fontSize: "smaller", color: "red" }}>
          Following fields are not applicable for Counter Party Applications
        </p>
      )}
      <Col sm={6} className="d-flex align-items-center">
        <Input
          label="Official Name"
          name="bank_official_name"
          required={
            getAppSelector.data.is_counterparty !== true ||
            role !== "Financier"
          }
          register={register}
          regexPattern={ALPHABETS_REGEX}
          placeholder="Enter official name"
          error={errors.bank_official_name?.message}
          disabled={
            getAppSelector.data.is_counterparty === true
              ? true
              : false
          }
        />
      </Col>
      <Col sm={6} className="d-flex align-items-center">
        <PhoneInputWithDropdown
          label="Official Phone"
          name="bank_official_phone"
          required={
            getAppSelector.data.is_counterparty !== true ||
            role !== "Financier"
          }
          register={register}
          regexPattern={PHONE_REGEX}
          isdCodeName={"phone_country_code"}
          isdCodeRegister={register}
          placeholder="Enter official phone"
          error={errors.bank_official_phone?.message}
          disabled={
            getAppSelector.data.is_counterparty === true
              ? true
              : false
          }
        />
      </Col>
    </Row>
    <Row>
      <Col sm={6} className="d-flex align-items-center">
        <Input
          label="Official Email"
          name="bank_official_email"
          required={
            getAppSelector.data.is_counterparty !== true ||
            role !== "Financier"
          }
          register={register}
          regexPattern={EMAIL_REGEX}
          placeholder="Enter official email"
          error={errors.bank_official_email?.message}
          disabled={
            getAppSelector.data.is_counterparty === true
              ? true
              : false
          }
        />
      </Col>
      <Col sm={6} className="d-flex align-items-center">
        <PhoneInputWithDropdown
          label="Official Mobile"
          name="bank_official_mobile"
          register={register}
          regexPattern={PHONE_REGEX}
          isdCodeName={"mobile_country_code"}
          isdCodeRegister={register}
          placeholder="Enter official mobile"
          error={errors.bank_official_mobile?.message}
          disabled={
            getAppSelector.data.is_counterparty === true
              ? true
              : false
          }
        />
      </Col>
    </Row>
  </div>
)}
*/}

              {/* <Col
                sm={12}
                style={{ fontSize: "86%", color: "#214382", marginTop: "3%" }}
              >
                <Form.Group
                  controlId="undertaking_confirm"
                  // defaultValue="No"
                  // defaultChecked
                >
                  <Form.Check
                    type="radio"
                    // defaultChecked={
                    //   localBankDetails.undertaking_confirm === "Yes"
                    //     ? true
                    //     : false
                    // }
                    label="We undertake and confirm that the above-mentioned details are of
                our Working capital account, or  "
                    value="Yes"
                    name="undertaking_confirm"
                    onChange={(e) => setDeclarationValue(e.target.value)}
                  />
                  <Form.Check
                    // defaultValue={localBankDetails.undertaking_confirm}
                    // defaultChecked={
                    //   localBankDetails.undertaking_confirm === "No"
                    //     ? true
                    //     : false
                    // }
                    type="radio"
                    label="We undertake and confirm that we do not avail any working
                    capital facility from any Bank, NBFC, or other financial
                    institutions. The above details are of our operative account for
                    carrying out day to day operations of our firm/ company."
                    value="No"
                    name="undertaking_confirm"
                    onChange={(e) => setDeclarationValue(e.target.value)}
                  />
                </Form.Group>
              </Col>
              {declarationError && (
                <p className="m-2" style={{ color: "#d64161" }}>
                  Please accept the Declaration
                </p>
              )} */}
              <Row>
                {/* <RadioButton
                  label="Declaration"
                  name="undertaking_confirm"
                  register={register}
                  required
                  requiredMessage="Please Select the above "
                  error={errors.is_default_bank?.message}
                  options={[
                    {
                      label:
                        "We undertake and confirm that the above-mentioned details are of  our Working capital account, or",
                      value: "Yes",
                    },
                    {
                      label:
                        "We undertake and confirm that we do not avail any working capital facility from any Bank, NBFC, or other financial institutions. The above details are of our operative account for carrying out day to day operations of our firm/ company.",
                      value: "No",
                    },
                  ]}
                /> */}
                {role !== "Financier" && (
                  <BankRadioButton
                    label={""}
                    required
                    requiredMessage="Please select the Declaration"
                    error={errors.undertaking_confirm?.message}
                    name={"undertaking_confirm"}
                    register={register}
                    options={[
                      {
                        label:
                          "We undertake and confirm that the above-mentioned details are of  our Working capital account, or",
                        value: "Yes",
                      },
                      {
                        label:
                          "We undertake and confirm that we do not avail any working capital facility from any Bank, NBFC, or other financial institutions. The above details are of our operative account for carrying out day to day operations of our firm/ company.",
                        value: "No",
                      },
                    ]}
                  />
                )}
              </Row>

              <Row>
                <Col md={20} className="text-end">
                  {showSpinner ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    <Button label="Update Details" type="submit"></Button>
                  )}
                </Col>
              </Row>
            </Form>
            <EditCorrBankAccountDetails />
          </Row>
        </Row>
      </Container>
      <Modal
        show={showPincodeSearchModal}
        onHide={handleClosePincodeSearchModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <SectionHeading text="SELECT ADDRESS " />
            {/* {pincodeValue} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addressByPincode.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Select</th>
                  <th>Address</th>
                  {/* <th>Branch Type</th> */}
                  <th>District</th>
                  <th>State</th>
                  <th>Pincode</th>
                </tr>
              </thead>
              <tbody>
                {addressByPincode.map((postOffice, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="radio"
                        name="selectedAddress"
                        value={postOffice.Name}
                        onChange={() => setSelectedAddress(postOffice)}
                      />
                    </td>
                    <td>
                      {postOffice.Name},{" "}
                      {postOffice.Block ? postOffice.Block : ""},{" "}
                      {postOffice.Name}
                    </td>
                    {/* <td>{postOffice.BranchType}</td> */}
                    <td>{postOffice.District}</td>
                    <td>{postOffice.State}</td>
                    <td>{postOffice.Pincode}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No addresses found</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handlePincodeSearchModalClose}>
      Close
    </Button> */}
          {/* <Button variant="primary" disabled={!selectedAddress} onClick={() => console.log("Selected Address:", selectedAddress)}>
      Confirm Address
    </Button> */}
          <Button
            label={"Confirm Address"}
            onClick={() => {
              // console.log("Selected Address:", selectedAddress?.Name);
              if (selectedAddress) {
                // setValue("city", selectedAddress.Name);
                // setValue("district", selectedAddress.District);
                // setValue("state", selectedAddress.State);
                // setValue(
                //   "country_id",
                //   selectedAddress.Country == "India" ? Number(process.env.REACT_APP_COUNTRY_ID) : null
                // );
                setValue("bank_address_city", selectedAddress.Name);
                setValue("bank_address_district", selectedAddress.District);
                setValue(
                  "bank_address_country_id",
                  selectedAddress.Country == "India"
                    ? Number(process.env.REACT_APP_COUNTRY_ID)
                    : "null"
                );
                setValue("bank_address_state", selectedAddress.State);

                const flagSetters = [
                  { setter: setCityFetched, value: selectedAddress.Name },
                  {
                    setter: setDistrictFetched,
                    value: selectedAddress.District,
                  },
                  { setter: setStateFetched, value: selectedAddress.State },
                ];

                flagSetters.forEach(({ setter, value }) => {
                  if (value) setter(true);
                });

                setAddLine1Fetched(false);
                setAddLine2Fetched(false);
                setPincodeFetched(false);

                handlePincodeSearchModalClose();
              }
            }}
          ></Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCurrencyModal}
        onHide={() => setShowCurrencyModal(false)}
        centered
        style={{
          color: "#214382",
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Bank Account Already Exists</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          For <strong>{selectedCurrency}</strong>, there is already a bank
          account added. Do you still want to add another one?
        </Modal.Body>
        <Modal.Footer>
          <Button
            label="Cancel"
            onClick={() => {
              reset({
                currency_id: 0,
              });
              setShowCurrencyModal(false);
            }}
            variant="outline-primary"
          />
          <Button
            label="Yes, Proceed"
            variant="primary"
            onClick={() => {
              setShowCurrencyModal(false);
              if (selectedCurrency === "INR") {
                setHideEEFC(true);
              } else {
                setHideEEFC(false);
              }
            }}
          ></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OpsEditLocalBankPage;
